import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-618b29e1")

_pushScopeId("data-v-618b29e1")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_12 = { style: {"text-align":"right"} }
const _hoisted_13 = { style: {"overflow":"hidden","text-overflow":"ellipsis","display":"block","width":"180px","white-space":"nowrap","word-break":"break-all"} }
const _hoisted_14 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_18 = {
  key: 2,
  style: {"margin":"0 5px"}
}
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { style: {"margin":"0 5px"} }, "|", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { style: {"margin":"0 5px"} }, "|", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { style: {"margin":"0 5px"} }, "|", -1)
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_25 = {
  ref: "mask_box",
  class: "gallery__big_wrap_smoke"
}
const _hoisted_26 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("清除标记")
const _hoisted_28 = { style: {"display":"flex","align-items":"center","flex-grow":"1","justify-content":"center"} }
const _hoisted_29 = { style: {"color":"#ff0"} }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" AI识别问题: ")
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("正确")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("错误")
const _hoisted_37 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_38 = { "element-loading-background": "rgba(0, 0, 0, 0)" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _withDirectives(_createVNode(_component_el_card, { class: "tableMinH" }, {
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini",
                    class: "spacForm"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "场景" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.sceneChange,
                            modelValue: _ctx.scene,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.scene = $event)),
                            "collapse-tags": "",
                            multiple: "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSelectAll('close', 'scene')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_1
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSelectAll('open', 'scene')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_2
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.smoke_scene_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "设备" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.deviceChange,
                            modelValue: _ctx.device,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.device = $event)),
                            "collapse-tags": "",
                            multiple: "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSelectAll('close', 'device')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_3
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSelectAll('open', 'device')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_4
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.smoke_device_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item.model__name,
                                  value: item.UUID
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "游戏时间" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.todChange,
                            modelValue: _ctx.tod,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.tod = $event)),
                            "collapse-tags": "",
                            multiple: "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleSelectAll('close', 'tod')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_5
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSelectAll('open', 'tod')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.smoke_tod_device_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "测试结果" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.todChange,
                            modelValue: _ctx.test_result,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.test_result = $event)),
                            "collapse-tags": "",
                            multiple: "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSelectAll('close', 'test_result')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSelectAll('open', 'test_result')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.text_status, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "问题类型" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.todChange,
                            modelValue: _ctx.problem_type,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.problem_type = $event)),
                            "collapse-tags": "",
                            multiple: "",
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_row, {
                                justify: "space-around",
                                type: "flex"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    class: "select-tag-class",
                                    style: {"width":"48%"},
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleSelectAll('close', 'problem_type')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_9
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tag, {
                                    type: "primary",
                                    style: {"width":"48%"},
                                    class: "select-tag-class",
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSelectAll('open', 'problem_type')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_10
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.problem_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "AI检测" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.ai_check,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.ai_check = $event))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.problem_check_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.name,
                                  label: item.name,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.confirm(false)))
                          }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("span", {
                      style: {"color":"#5cb6ff","cursor":"pointer"},
                      onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.addBtn && _ctx.addBtn(...args)))
                    }, "新增对比列"),
                    _createVNode("span", {
                      style: {"color":"#5cb6ff","cursor":"pointer","margin-left":"10px"},
                      onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.exportBtn && _ctx.exportBtn(...args)))
                    }, "导出离线HTML"),
                    _createVNode("span", {
                      style: {"color":"#5cb6ff","cursor":"pointer","margin-left":"10px"},
                      onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.exportBtnOl && _ctx.exportBtnOl(...args)))
                    }, "导出在线HTML")
                  ]),
                  _withDirectives(_createVNode(_component_el_table, {
                    style: {"width":"100%"},
                    ref: "elTable",
                    size: "small",
                    id: "detailTable",
                    data: _ctx.newData.slice((_ctx.page - 1) * (_ctx.size * 2), _ctx.page * (_ctx.size * 2)),
                    "span-method": _ctx.mergeCells2,
                    "header-cell-class-name": "tabelHeader"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_table_column, {
                        width: "130",
                        prop: "date",
                        label: "场景"
                      }, {
                        default: _withId((scope) => [
                          _createVNode("span", null, _toDisplayString(scope.row.scene), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        width: "110",
                        prop: "date",
                        label: "设备"
                      }, {
                        default: _withId((scope) => [
                          _createVNode("span", null, _toDisplayString(scope.row.device), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        width: "110",
                        prop: "date",
                        label: "游戏时间"
                      }, {
                        default: _withId((scope) => [
                          _createVNode("span", null, _toDisplayString(scope.row.tod), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        width: "180",
                        prop: "date",
                        label: "坐标"
                      }, {
                        default: _withId((scope) => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            placement: "top",
                            content: scope.row.positon
                          }, {
                            default: _withId(() => [
                              _createVNode("span", _hoisted_13, _toDisplayString(scope.row.positon), 1)
                            ]),
                            _: 2
                          }, 1032, ["content"])
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.version_list, (item, i) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          width: "330",
                          key: item,
                          label: item
                        }, {
                          header: _withId(() => [
                            _createVNode("div", _hoisted_14, [
                              _createVNode("div", null, [
                                _createVNode("div", null, _toDisplayString(item ? item.split("|")[0] : ""), 1),
                                (item.indexOf('|') != -1)
                                  ? (_openBlock(), _createBlock("div", _hoisted_15, _toDisplayString(item ? item.split("|")[1] : ""), 1))
                                  : (_openBlock(), _createBlock("div", _hoisted_16, _toDisplayString(item ? _ctx.labelTime(item) : ""), 1))
                              ]),
                              _createVNode("div", null, [
                                _createVNode("i", {
                                  onClick: ($event: any) => (_ctx.deleteBtn(item)),
                                  class: "el-icon-remove"
                                }, null, 8, ["onClick"])
                              ])
                            ]),
                            (_ctx.add_show && i == _ctx.version_list.length - 1)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  style: {"margin-left":"200px"},
                                  onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.add_btn())),
                                  size: "mini",
                                  modelValue: _ctx.add_version,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.add_version = $event))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.smoke_version_list, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: index,
                                        label: item.version + '(' + item.date + ')',
                                        value: item.version
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withId((scope) => [
                            (scope.$index % 2 === 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                  (
                      _ctx.editing.row !== scope.$index ||
                      _ctx.editing.column !== item ||
                      _ctx.editing.type !== 'status'
                    )
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 0,
                                        class: "custom-span",
                                        onClick: ($event: any) => (
                      _ctx.startEditing(
                        scope.$index,
                        item,
                        'status',
                        scope.row[item]?.[scope.row.name]?.image
                      )
                    ),
                                        style: 
                      'font-weight:bold;color:' +
                      _ctx.getColor(scope.row[item]?.[scope.row.name]?.result)
                    
                                      }, _toDisplayString(scope.row[item]?.[scope.row.name]?.result), 13, ["onClick"]))
                                    : (_openBlock(), _createBlock(_component_el_select, {
                                        key: 1,
                                        ref: `select-${scope.$index}-${item}`,
                                        size: "mini",
                                        modelValue: scope.row[item][scope.row.name].result,
                                        "onUpdate:modelValue": ($event: any) => (scope.row[item][scope.row.name].result = $event),
                                        placeholder: "请选择",
                                        onBlur: ($event: any) => (_ctx.delayStopEditing(scope.row[item][scope.row.name])),
                                        onChange: ($event: any) => (_ctx.stopEditing(scope.row[item][scope.row.name]))
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.text_status, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item,
                                              label: item,
                                              value: item
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur", "onChange"])),
                                  (
                      scope.row[item]?.[scope.row.name]?.result !== '通过' &&
                      scope.row[item]?.[scope.row.name]?.result !== '未测试'
                    )
                                    ? (_openBlock(), _createBlock("div", _hoisted_18, " | "))
                                    : _createCommentVNode("", true),
                                  (
                      scope.row[item]?.[scope.row.name]?.result !== '通过' &&
                      scope.row[item]?.[scope.row.name]?.result !== '未测试' &&
                      (_ctx.editing.row !== scope.$index ||
                        _ctx.editing.column !== item ||
                        _ctx.editing.type !== 'problem_type')
                    )
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 3,
                                        onClick: ($event: any) => (
                      _ctx.startEditing(
                        scope.$index,
                        item,
                        'problem_type',
                        scope.row[item]?.[scope.row.name]?.image
                      )
                    )
                                      }, _toDisplayString(scope.row[item]?.[scope.row.name]?.problem_type
                        ? scope.row[item]?.[scope.row.name]?.problem_type
                        : "添加类型"), 9, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (
                      _ctx.editing.row === scope.$index &&
                      _ctx.editing.column === item &&
                      _ctx.editing.type == 'problem_type'
                    )
                                    ? (_openBlock(), _createBlock(_component_el_select, {
                                        key: 4,
                                        ref: `select-${scope.$index}-${item}`,
                                        size: "mini",
                                        onBlur: ($event: any) => (_ctx.delayStopEditing(scope.row[item][scope.row.name])),
                                        onChange: ($event: any) => (_ctx.stopEditing(scope.row[item][scope.row.name])),
                                        modelValue: scope.row[item][scope.row.name].problem_type,
                                        "onUpdate:modelValue": ($event: any) => (scope.row[item][scope.row.name].problem_type = $event),
                                        placeholder: "请选择"
                                      }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.problem_list, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item,
                                              label: item,
                                              value: item
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["onBlur", "onChange", "modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true),
                                  _hoisted_19,
                                  (scope.row[item]?.[scope.row.name]?.bug_url)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 5,
                                        class: "download-link",
                                        onClick: _withModifiers(($event: any) => (
                      _ctx.handleClick(scope.row[item][scope.row.name], $event)
                    ), ["prevent"])
                                      }, "BUG链接", 8, ["onClick"]))
                                    : (_openBlock(), _createBlock("span", {
                                        key: 6,
                                        onClick: ($event: any) => (
                      _ctx.add_bug(
                        scope.row[item][scope.row.name],
                        scope.row[item]?.[scope.row.name]?.image
                      )
                    )
                                      }, "+BUG链接", 8, ["onClick"])),
                                  _hoisted_20,
                                  (
                      _ctx.editing.row !== scope.$index ||
                      _ctx.editing.column !== item ||
                      _ctx.editing.type !== 'remark'
                    )
                                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                        key: 7,
                                        effect: "dark",
                                        content: 
                      scope.row[item]?.[scope.row.name]?.remark
                        ? scope.row[item]?.[scope.row.name]?.remark
                        : '添加备注'
                    ,
                                        placement: "top"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode("span", {
                                            class: "ellipsis",
                                            onClick: ($event: any) => (
                        _ctx.remarkBtn(
                          scope.$index,
                          item,
                          'remark',
                          scope.row[item]?.[scope.row.name]?.image
                        )
                      )
                                          }, _toDisplayString(scope.row[item]?.[scope.row.name]?.remark
                          ? scope.row[item]?.[scope.row.name]?.remark
                          : "添加备注"), 9, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1032, ["content"]))
                                    : _createCommentVNode("", true),
                                  (
                      _ctx.editing.row === scope.$index &&
                      _ctx.editing.column === item &&
                      _ctx.editing.type === 'remark'
                    )
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 8,
                                        style: {"width":"100px"},
                                        size: "mini",
                                        ref: "select",
                                        onBlur: ($event: any) => (_ctx.stopEditing(scope.row[item][scope.row.name])),
                                        onChange: ($event: any) => (_ctx.stopEditing(scope.row[item][scope.row.name])),
                                        modelValue: scope.row[item][scope.row.name].remark,
                                        "onUpdate:modelValue": ($event: any) => (scope.row[item][scope.row.name].remark = $event)
                                      }, null, 8, ["onBlur", "onChange", "modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true),
                                  _hoisted_21,
                                  _createVNode("span", {
                                    style: 
                      'color:' +
                      (scope.row[item][scope.row.name].ai_check?.length > 0
                        ? 'red'
                        : '')
                    
                                  }, _toDisplayString(scope.row[item][scope.row.name].ai_check?.length > 0
                        ? "AI异常"
                        : "AI正常"), 5)
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_22, [
                                  (scope.row[item]?.[scope.row.name]?.image)
                                    ? (_openBlock(), _createBlock(_component_el_image, {
                                        key: 0,
                                        "data-src": scope.row[item]?.[scope.row.name]?.image,
                                        onClick: ($event: any) => (
                      _ctx.imgBtn(
                        scope.row[item]?.[scope.row.name]?.image,
                        scope.row.img_list,
                        i,
                        item,
                        scope.row.name
                      )
                    ),
                                        style: {"max-width":"200px"},
                                        src: scope.row[item]?.[scope.row.name]?.little_image
                                      }, null, 8, ["data-src", "onClick", "src"]))
                                    : (_openBlock(), _createBlock("div", _hoisted_23, "无数据"))
                                ]))
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["data", "span-method"]), [
                    [_directive_loading, _ctx.tableLoading]
                  ]),
                  _createVNode(_component_el_form, {
                    style: {"display":"flex","align-items":"center","margin":"20px 0"},
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        style: {"margin-bottom":"0"},
                        label: "每页"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.size,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.size = $event)),
                            style: {"width":"55px","height":"28px"},
                            onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onSearch()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        style: {"margin-bottom":"0"},
                        label: "条记录"
                      }),
                      _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                        default: _withId(() => [
                          _createVNode(_component_el_pagination, {
                            style: {"text-align":"right"},
                            currentPage: _ctx.page,
                            "onUpdate:currentPage": _cache[25] || (_cache[25] = ($event: any) => (_ctx.page = $event)),
                            "page-size": _ctx.size,
                            total: _ctx.newData?.length / 2,
                            layout: "total, prev, pager, next,jumper"
                          }, null, 8, ["currentPage", "page-size", "total"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_dialog, {
                    width: "40%",
                    modelValue: _ctx.configShow,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.configShow = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, {
                            style: {"width":"500px"},
                            label: "BUG链接"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.bugModel,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.bugModel = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withId(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _ctx.bugBtn
                              }, {
                                default: _withId(() => [
                                  _hoisted_24
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 512), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode("div", {
            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.maskBtn($event))),
            onWheel: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.handleWheel && _ctx.handleWheel(...args))),
            class: "gallery__big"
          }, [
            _createVNode("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _createVNode("i", {
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.leftBtn(_ctx.mask?.img))),
                  class: 'imgBtnClass'
                }),
                _createVNode("div", {
                  style: {
                width: _ctx.canvasWidth + 'px',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }
                }, [
                  _createVNode(_component_el_button, {
                    size: "mini",
                    type: "primary",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.deleteCanvas()))
                  }, {
                    default: _withId(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_28, [
                    _createVNode("span", _hoisted_29, [
                      _hoisted_30,
                      (_ctx.problem_img_list?.length > 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_31, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.problem_img_list, (item, index) => {
                              return (_openBlock(), _createBlock("span", { key: index }, [
                                _createTextVNode(_toDisplayString(item.name), 1),
                                (item.value)
                                  ? (_openBlock(), _createBlock("span", _hoisted_32, "置信度：" + _toDisplayString(item.value), 1))
                                  : _createCommentVNode("", true),
                                (index < _ctx.problem_img_list.length - 1)
                                  ? (_openBlock(), _createBlock("span", _hoisted_33, "，"))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_34, "无异常"))
                    ]),
                    _createVNode(_component_el_radio_group, {
                      style: {"margin-left":"15px"},
                      onChange: _ctx.radioChange,
                      modelValue: _ctx.radio1,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.radio1 = $event)),
                      class: "ml-4"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_radio, {
                          label: 1,
                          class: {
                      'radio-correct': _ctx.radio1 === 1,
                      'radio-default': _ctx.radio1 !== 1,
                    },
                          size: "large"
                        }, {
                          default: _withId(() => [
                            _hoisted_35
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_radio, {
                          label: 0,
                          class: {
                      'radio-incorrect': _ctx.radio1 === 0,
                      'radio-default': _ctx.radio1 !== 0,
                    },
                          size: "large"
                        }, {
                          default: _withId(() => [
                            _hoisted_36
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    }, 8, ["onChange", "modelValue"])
                  ])
                ], 4),
                _createVNode("i", {
                  onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.rightBtn(_ctx.mask?.img))),
                  class: 'imgBtnClass'
                })
              ]),
              _createVNode("div", _hoisted_37, [
                _createVNode("i", {
                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.leftBtn(_ctx.mask?.img))),
                  class: _ctx.leftShow + ' ' + 'imgBtnClass'
                }, null, 2),
                _createVNode("div", null, [
                  _createVNode("img", {
                    ref: "image",
                    src: _ctx.mask.img,
                    style: {"max-width":"80%","display":"none"}
                  }, null, 8, ["src"])
                ]),
                _withDirectives(_createVNode("div", _hoisted_38, [
                  _createVNode("div", {
                    ref: "container",
                    style: {
                  width: _ctx.canvasWidth + 'px',
                  height: _ctx.canvasHeight + 'px',
                }
                  }, null, 4)
                ], 512), [
                  [_directive_loading, _ctx.img_loading]
                ]),
                _createVNode("i", {
                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.rightBtn(_ctx.mask?.img))),
                  class: _ctx.rightShow + ' ' + 'imgBtnClass'
                }, null, 2)
              ])
            ], 512)
          ], 544), [
            [_vShow, _ctx.showMask]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})